import { RootState } from '../redux/index';

export const selectEula = (state: RootState) => state.eula;
